import { render, staticRenderFns } from "./Faturas.vue?vue&type=template&id=3577d372"
import script from "./Faturas.vue?vue&type=script&lang=js"
export * from "./Faturas.vue?vue&type=script&lang=js"
import style0 from "./Faturas.vue?vue&type=style&index=0&id=3577d372&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports